import React, { useState, useEffect, useRef } from 'react';
import {
    Box,
    HStack,
    Input,
    VStack,
    Select,
    Textarea,
    Button,
    Text
} from '@chakra-ui/react';

import Const from '../Constants';

import { showSuccessToast } from '../Utils';

const Feedback = ({ auth, toast }) => {
    

    const [title, setTitle] = useState('');
    const titleInputRef = useRef(null);

    const [body, setBody] = useState('');

    // Initialize state for the selected value
    const [selectedOption, setSelectedOption] = useState(Const.sFeature);

    useEffect(() => {
        // If the title is empty set the focus on title input
        if(!title && titleInputRef.current) {
            titleInputRef.current.focus();
        }
    }, [title]);

    // Create a handler function to update the state
    const handleSelectChange = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleAddFeedback = async () => {
        try {
          const idToken = await auth.currentUser.getIdToken();
          const theURL = process.env.REACT_APP_BASE_URL + Const.sFeedbacksPath;
          const response = await fetch(theURL, {
            method: Const.HttpPut,
            headers: new Headers({
              Authorization: idToken,
              Accept: Const.AppJson,
              [Const.ContentType]: Const.AppJson
            }),
            body: JSON.stringify({
                type: selectedOption,
                title: title,
                body: body
              })
          });
    
          // Check if the request was successful
          if(!response.ok) {
            throw new Error('Failed to add feedback');
          }

          // Show the toast notification
          showSuccessToast(toast, 'Feedback Submitted', 'Thank you for the feedback!');

          // Reset controls
          setTitle('');
          setBody('');
          setSelectedOption(Const.sFeature);

        } catch (error) {
          console.error(error.message);
        }
      };

    return (
        <Box w={'100%'} h={'100%'} display='flex' alignItems='center' justifyContent='center'>
            <VStack
                w={'560px'}
                spacing={3}
                background={Const.Gray36}
                borderRadius={Const.LG}
                padding={6}
            >
                <Text
                    alignSelf='flex-start'
                    fontSize={Const.MD}
                    fontWeight={Const.Bold}
                    color={Const.White}
                >
                    Send Feedback
                </Text>

                <Input
                    ref={titleInputRef}
                    fontSize={Const.SM}
                    value={title}
                    borderColor={Const.Gray64}
                    placeholder={'Title'}
                    _placeholder={{ color: Const.Gray100 }}
                    onChange={(event) => setTitle(event.target.value)}
                    onKeyDown={(event) => {
                        if (event.key === Const.sEnter) {
                            titleInputRef.current.blur();
                            event.preventDefault();
                        }
                    }}
                />

                <Select
                    fontSize={Const.SM}
                    alignSelf='flex-start'
                    w={'180px'}
                    color={Const.Gray180}
                    borderColor={Const.Gray64}
                    value={selectedOption}
                    onChange={handleSelectChange}
                >
                    <option value={Const.sFeature}>Feature request</option>
                    <option value='bug'>Bug report</option>
                    <option value='other'>Other</option>
                </Select>

                <Textarea
                    value={body}
                    fontSize={Const.SM}
                    h={'200px'}
                    resize={Const.sNone}
                    borderColor={Const.Gray64}
                    placeholder={'Describe your feedback...'}
                    _placeholder={{ color: Const.Gray100 }}
                    onChange={(event) => setBody(event.target.value)}
                />

                <HStack w={'100%'} justifyContent='flex-end'>
                    <Button
                        background={'#276749'}
                        color={Const.White}
                        _hover={{ background: '#38A169' }}
                        fontSize={Const.SM}
                        isDisabled={!title.trim() && !body.trim()}
                        onClick={handleAddFeedback}
                    >
                        Submit feedback
                    </Button>
                </HStack>
            </VStack>
        </Box>
    );
};

export default Feedback;
